/**
 * service服务器端是直接从请求头里拿host和proto拼接的,所以nginx config里配置一定要设置host和x-forwarded-proto!!!
 * 非常重要，否则会导致服务端渲染出错而无法访问
 * @returns 
 */

export async function getOrigin(): Promise<string> {
  // 客户端（最简单）
  if (typeof window !== 'undefined') {
    return window.location.origin
  }

  // 服务端（Next.js 环境）
  const { headers } = await import('next/headers')
  const h = await headers()

  // 优先代理头（vercel / nginx / cloudflare 都这么干）
  const host =
    h.get('x-forwarded-host') ??
    h.get('host') ??
    'localhost:3000'

  let proto =
    h.get('x-forwarded-proto') ??
    'http'

  // 某些代理会返回 "https,http" 这种值，需要取第一个
  if (proto.includes(',')) {
    proto = proto.split(',')[0]
  }

  return `${proto}://${host}`
}

